<script setup lang="ts">
import {onMounted, onUnmounted, ref, watch} from 'vue'
import {useRoute} from 'vue-router'
import {useI18n} from 'vue-i18n'
import {Sessions} from '@/assets/ts/sessions'

const route = useRoute()
const {t} = useI18n()
const sessionsApi: Sessions = new Sessions()

const loading = ref(false)
const error = ref<number | null>(null)
const pdfUrl = ref<string | null>(null)
const pageStr = 'components.itemV2.itemV2PrintOut'
let isRedirecting = false

const loadPdf = async () => {
  const routeSessionId = route.params.sessionId?.toString() || ''
  if (!routeSessionId) return

  loading.value = true
  error.value = null
  try {
    const data: any = await sessionsApi.getPdf(routeSessionId)
    if (data.file) {
      if (pdfUrl.value) {
        URL.revokeObjectURL(pdfUrl.value)
      }
      const pdfBase64 = data.file
      const byteCharacters = atob(pdfBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], {type: 'application/pdf'})
      pdfUrl.value = URL.createObjectURL(blob)
      isRedirecting = true
      window.location.replace(pdfUrl.value)
    } else if (typeof data.error !== 'undefined') {
      error.value = data.error
    }
  } catch (e) {
    console.error(e)
    error.value = 500
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  loadPdf()
  document.title = t(pageStr + '.configuration_printout')
})

onUnmounted(() => {
  if (pdfUrl.value && !isRedirecting) {
    URL.revokeObjectURL(pdfUrl.value)
  }
})

watch(
    () => route.params.sessionId,
    () => loadPdf()
)

</script>

<template>
    <div class="pdf-container">
      <div v-if="loading" class="state-container">
        <p>{{ t(pageStr + '.loading_configuration') }}</p>
      </div>
      <div v-else-if="error" class="state-container error-text">
        <p>{{ t(pageStr + '.error') }} {{ error }}</p>
      </div>
    </div>
</template>

<style scoped>
.pdf-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 9999;
  background-color: white;
}
.state-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-family: sans-serif;
}
.error-text {
  color: red;
}
</style>

